import React from "react";
import "./ContactMe.css";
import ContactMeCard from "./ContactMeCard/ContactMeCard";
import ContactForm from "./ContactForm/ContactForm";

const LINKEDIN_URL = "https://www.linkedin.com/in/edison-javier-fiallos-barros-99ab9b225";

const ContactMe = () => {
  return (
    <section className="contact-container" id="contact">
      <div className="section-cmd-header-c">
        <span className="cmd-prompt-c">❯</span>
        <span className="cmd-text-c">
          ssh <span className="cmd-flag-c">javif@contact</span> --connect
        </span>
      </div>
      <h2 className="section-label-c">{'// Contáctame'}</h2>

      <div className="contact-content">
        <div style={{ flex: 1 }}>
          <p className="contact-intro-line">
            <span className="contact-arrow">▸</span> Canales de comunicación:
          </p>
          <ContactMeCard
            iconURL={"./assets/images/mailcon.png"}
            text={"fiallosjavier1e@gmail.com"}
            href={"mailto:fiallosjavier1e@gmail.com"}
          />
          <ContactMeCard
            iconURL={"./assets/images/linkedinIcon.svg"}
            text={"linkedin.com/in/edison-javier-fiallos-barros"}
            href={LINKEDIN_URL}
          />
          <ContactMeCard
            iconURL={"./assets/images/githubIcon.svg"}
            text={"github.com/JaviFiallos"}
            href={"https://github.com/JaviFiallos"}
          />
        </div>
        <div style={{ flex: 1 }}>
          <ContactForm />
        </div>
      </div>

      <div className="iconos-contacto">
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="boton-link"
          aria-label="LinkedIn"
        >
          <button className="boton" id="boton1" aria-label="LinkedIn" />
        </a>
        <button className="boton" id="boton2" aria-label="Instagram" />
        <button className="boton" id="boton3" aria-label="Twitter" />
        <button className="boton" id="boton4" aria-label="Facebook" />
      </div>
    </section>
  );
};

export default ContactMe;

